<template>
  <section>
    <!-- start of appbar -->
    <v-app-bar dense :clipped-left="$vuetify.breakpoint.lgAndUp" app color="#f4f5fa" flat>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <!-- <v-toolbar-title class="ml-0 pl-4" style="margin-right: 100px">
        <span class="hidden-sm-and-down">{{storeName}}</span>
      </v-toolbar-title>-->
      <!-- <span style="inline-block;font-size: 24px;  margin-right: 5px; color: #16b1ff; font-weight: bold">SN MORIASI LTD</span> -->
      <!-- <span style="inline-block;font-size: 24px; margin-left: 75px; margin-right: 5px; color: #FF5733; font-weight: bold">{{
        storeName
      }}</span>-->
      <!-- <span style="inline-block;font-size: 24px;  margin-right: 5px; color: #16b1ff; font-weight: bold">{{
        storeName
      }}</span>-->

      <span
        style="font-size: 16px;  margin-right: 5px; color: #16b1ff; font-weight: bold"
      ></span>
      
      <span v-if="IsDistributor == 'N'" class="custom-accent style-16" style="margin-left: 5px">{{ storeName }}</span>

      <span v-if="IsDistributor == 'Y'" class="custom-accent style-16" style="margin-left: 5px">{{ companyName }}</span>
      
      <!-- start of menu -->
      <div v-show="!$vuetify.breakpoint.xs">
        <!-- top menu was here -->
      </div>
      <!-- end of menu -->

      <v-spacer />
      
      <v-btn v-show="role == 3" text to="/billing">Billing</v-btn>
      <v-btn text>{{ userName }}</v-btn>
      <v-btn text @click="logout">
        Logout
        <v-icon right>mdi-application-import</v-icon>
      </v-btn>

      <!-- <v-btn text color="white" @click="logout">Logout</v-btn> -->
    </v-app-bar>
    <!-- end of appbar -->
    <!-- style="background-color: #3c3851;" -->

    <!-- start of sidebar -->
    <v-navigation-drawer
    id="navDrawer"
      style="background-color: #3c3851;"
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <!-- if desktop -->
      <v-list dense class="hidden-sm-and-down">
        <template v-for="item in sideMenu">
          <v-row v-if="item.heading" :key="item.heading" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-col>
            <v-col cols="6" class="text-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children.length > 0"
            :key="item.text"
            v-model="item.model"
            append-icon
          >
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon color="white">mdi-chevron-down</v-icon>
              </v-list-item-icon>
              <v-list-item :to="item.link">
                <v-list-item-content>
                  <v-list-item-title class="white--text" style="font-size: 14px">{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item v-for="(child, i) in item.children" :key="i" :to="child.link">
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text" style="font-size: 14px">{{ child.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="item.text" :to="item.link">
            <v-list-item-action>
              <v-icon class="white--text">{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="white--text" style="font-size: 14px">{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <!-- end -->

      <!-- start of mobile menu-->
      <v-list class="hidden-md-and-up">
        <template v-for="(item, i) in mobileMenu">
          <v-list-group
            :model="falseValue"
            v-if="item.children && item.children.length > 0"
            :key="i"
            :prepend-icon="item.icon"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </template>

            <template v-for="child in item.children">
              <!-- with sub children -->
              <v-list-group
                :model="falseValue"
                v-if="child.children && child.children.length > 0"
                :key="child.text"
                no-action
                sub-group
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ child.text }}</v-list-item-title>
                  </v-list-item-content>
                </template>

                <!-- sub children template -->
                <template v-for="subChild in child.children">
                  <v-list-group
                    :model="falseValue"
                    v-if="subChild.childre && subChild.children.length > 0"
                    :key="subChild.text"
                    no-action
                    sub-group
                  >
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{
                          subChild.text
                          }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>

                    <v-list-item
                      v-for="(grandChild, i) in subChild.children"
                      :key="i"
                      :to="grandChild.link"
                    >
                      <v-list-item-icon style="margin-left: -30px" :to="item.link">
                        <v-icon color="accent">mdi-format-list-bulleted</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title style="margin-left: -15px" v-text="grandChild.text"></v-list-item-title>
                    </v-list-item>
                  </v-list-group>

                  <!-- no grand child -->
                  <v-list-item v-else :key="subChild.text" :to="subChild.link">
                    <v-list-item-icon style="margin-left: -45px">
                      <v-icon color="red">mdi-format-line-weight</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title style="margin-left: -15px">
                      {{
                      subChild.text
                      }}
                    </v-list-item-title>
                  </v-list-item>
                  <!-- end of no grand children -->
                </template>
                <!-- end of sub children template -->
              </v-list-group>
              <!-- end of with children -->

              <!-- no sub children -->
              <v-list-item v-else :key="child.text" @click="navigate(child.link)">
                <v-list-item-icon>
                  <v-icon>mdi-con</v-icon>
                </v-list-item-icon>

                <v-list-item-title>{{ child.text }}</v-list-item-title>
              </v-list-item>
              <!-- end of no sub children -->
            </template>
          </v-list-group>

          <v-list-item v-else :key="i" @click="navigate(item.link)">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
      <!-- end of mobile menu-->
    </v-navigation-drawer>
    <!-- end of sidebar -->
  </section>
</template>

<script>
export default {
  computed: {
    items() {
      const role = localStorage.getItem("userRole");
      return this.myitems.filter(item => {
        return item.role <= role;
      });
    },
    filteredMasterMenus() {
      const role = localStorage.getItem("userRole");
      return this.masterMenus.filter(item => {
        return item.role <= role;
      });
    },
    filteredStockMenus() {
      const role = localStorage.getItem("userRole");
      return this.stockMenus.filter(item => {
        return item.role <= role;
      });
    },
    filteredInitMenus() {
      const role = localStorage.getItem("userRole");
      return this.initMenus.filter(item => {
        return item.role <= role;
      });
    },
    filteredActionMenus() {
      const role = localStorage.getItem("userRole");
      return this.actionMenus.filter(item => {
        return item.role <= role;
      });
    },
    filteredReportMenus() {
      const role = localStorage.getItem("userRole");
      return this.reportMenus.filter(item => {
        return item.role <= role;
      });
    },
    role() {
      return localStorage.getItem("userRole");
    },
    userName() {
      return localStorage.getItem("userName");
    },
    companyName() {
      return localStorage.getItem("companyName");
    },
    storeName() {
      return localStorage.getItem("storeName");
    },
    userId() {
      return localStorage.getItem("user_id");
    }
  },
  data: () => ({
    IsDistributor: "",
    drawer: true,
    trueValue: true,
    falseValue: false,
    fav: true,
    menu: false,
    message: false,
    hints: true,
    topMenu: [],
    sideMenu: [],
    mobileMenu: [],
    setupMenus: [],
    returnMenus: []
  }),
  methods: {
    changeTrue() {
      this.trueValue = true;
    },
    changeFalse() {
      this.trueValue = false;
    },
    navigate(link) {
      this.$router.push(link);
    },
    navigateMenu(link) {
      this.$router.push(link);
      this.menu = !this.menu;
    },
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("userName");
      localStorage.removeItem("userRole");
      localStorage.removeItem("store_id");
      localStorage.removeItem("user_id");
      localStorage.removeItem("subscriber_id");
      localStorage.removeItem("storeName");
      localStorage.removeItem("company_id");
      localStorage.removeItem("companyName");
      this.$router.push("/login");
    },
    getMenu() {
      const userId = this.userId;
      const url = `/menu-setup-user/${userId}`;
      const self = this;
      this.$store
        .dispatch("get", url)
        .then(res => {
          self.sideMenu = res.ResponseData;
          self.mobileMenu = res.ResponseData;
          self.$store.commit("loader", false);
        })
        .catch(() => {});
    },
    getGeneralSettings() {
      const url = `/general-settings`;
      const self = this;
      this.$store
        .dispatch("get", url)
        .then(res => {
          self.IsDistributor = res.ResponseData.IsDistributor;
          self.$store.commit("loader", false);
        })
        .catch(() => {});
    }
  },
  created() {
    Promise.all([this.getMenu(), this.getGeneralSettings()]);
  }
};
</script>

<style scoped>
.white-icon {
  color: white;
}
</style>
